import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-screensTypeBoth",
  "use": "svg-icon-screensTypeBoth-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"svg-icon-screensTypeBoth\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0-1h16v16H0z\" /><path d=\"M0 0h8v14H0V0zm9 12h5V7H9V5h7v9H9v-2zm-3 0H2V2h4v10z\" fill=\"#000\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol